import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'
import { Header } from '@/components/generals/header'
import { ScrollProgress } from '@/components/motion/scroll-progress'

export const Layout: FC<LayoutProps> = ({
    children,
    profile = null,
    year,
    isHome = false
}): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col overflow-x-clip'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-full focus:bg-foreground focus:px-4 focus:py-2 focus:text-background'
            >
                Skip to content
            </a>

            <ScrollProgress />
            <Header profile={profile} isHome={isHome} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer profile={profile} year={year} />

            <div aria-hidden='true' className='grain pointer-events-none fixed inset-0 z-[70] opacity-[0.045]' />
        </div>
    )
}
